import { call, put, take, takeEvery } from "redux-saga/effects";
import { UserProfileConstants } from "../constants/userProfile.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    userCorrectionsSuccess,
    userCorrectionsFailure,
    userPostsSuccess,
    userPostsFailure,
    userProfileInitSuccess,
    userProfileInitFailure
} from "../actions/userProfile.actions";
import { getUserQuery } from "./query.helper";
import { graphQLCorrectionContents, graphQLPostContents } from "./query.helper";

export function* userProfileInit() {
    yield takeEvery(UserProfileConstants.USER_PROFILE_INIT, doFetchUserProfile);
}

function* doFetchUserProfile({ payload: { uid } }) {
    try {
        const response = yield call(doGraphQLQuery, getUserQuery(uid));
        yield put(userProfileInitSuccess(response));
    } catch (e) {
        yield call(handleFailure, e, userProfileInitFailure);
    }
}

export function* userPosts() {
    while (true) {
        let { payload: { uid, after } } = yield take(
            UserProfileConstants.USER_POSTS
        );
        try {
            after = after || "";
            const query = `{
                posts(
                    userId: ${JSON.stringify(uid)}
                    after: ${JSON.stringify(after)}
                    first: 10
                ) ${graphQLPostContents(true)}
            }`;
            const response = yield call(doGraphQLQuery, query);
            yield put(userPostsSuccess(response));
        } catch (e) {
            yield call(handleFailure, e, userPostsFailure);
        }
    }
}

export function* userCorrections() {
    while (true) {
        let { payload: { uid, after } } = yield take(
            UserProfileConstants.USER_CORRECTIONS
        );
        try {
            after = after || "";
            const query = `{
            corrections(
                userId: ${JSON.stringify(uid)}
                after: ${JSON.stringify(after)}
                first: 10
            ) ${graphQLCorrectionContents(true)}
        }`;
            const response = yield call(doGraphQLQuery, query);
            yield put(userCorrectionsSuccess(response));
        } catch (e) {
            yield call(handleFailure, e, userCorrectionsFailure);
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/userProfile.saga.js